var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1327_3441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.232422,
    y: 0.143555,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1327_3441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5658 17.6436L11.3158 12.3936C10.8991 12.7269 10.4199 12.9908 9.87825 13.1852C9.33659 13.3797 8.7602 13.4769 8.14909 13.4769C6.6352 13.4769 5.35395 12.9526 4.30534 11.904C3.25673 10.8554 2.73242 9.57411 2.73242 8.06022C2.73242 6.54633 3.25673 5.26508 4.30534 4.21647C5.35395 3.16786 6.6352 2.64355 8.14909 2.64355C9.66298 2.64355 10.9442 3.16786 11.9928 4.21647C13.0414 5.26508 13.5658 6.54633 13.5658 8.06022C13.5658 8.67133 13.4685 9.24772 13.2741 9.78939C13.0796 10.3311 12.8158 10.8102 12.4824 11.2269L17.7324 16.4769L16.5658 17.6436ZM8.14909 11.8102C9.19076 11.8102 10.0762 11.4456 10.8053 10.7165C11.5345 9.9873 11.8991 9.10189 11.8991 8.06022C11.8991 7.01855 11.5345 6.13314 10.8053 5.40397C10.0762 4.6748 9.19076 4.31022 8.14909 4.31022C7.10742 4.31022 6.22201 4.6748 5.49284 5.40397C4.76367 6.13314 4.39909 7.01855 4.39909 8.06022C4.39909 9.10189 4.76367 9.9873 5.49284 10.7165C6.22201 11.4456 7.10742 11.8102 8.14909 11.8102Z",
    fill: "#28398A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutlined);
export default __webpack_public_path__ + "static/media/search_outlined.2329587a38a252e2c0a51d5507bef4b2.svg";
export { ForwardRef as ReactComponent };